import React from 'react'
import { COLORS, isNum, fmtValue, fmtPctShort, gradeColor } from './sprayReportUtils'

// Compact score summary for the flight details page; opens the full report
const ScoreRing = ({ score, max, grade, color }) => {
    const r = 30, c = 2 * Math.PI * r
    const ratio = isNum(score) ? Math.min(Math.max(score / (max || 100), 0), 1) : 0
    return (
        <svg className="sqs-ring" viewBox="0 0 76 76">
            <circle cx="38" cy="38" r={r} fill="none" stroke="#EEF0F4" strokeWidth="7" />
            <circle cx="38" cy="38" r={r} fill="none" stroke={color} strokeWidth="7" strokeLinecap="round"
                strokeDasharray={`${c * ratio} ${c}`} transform="rotate(-90 38 38)" />
            <text x="38" y="46" textAnchor="middle" fontSize="24" fontWeight="700" fill={color}>{grade || 'NA'}</text>
        </svg>
    )
}

const Stat = ({ label, value, color }) => (
    <div className="sqs-stat">
        <span className="sqs-stat-dot" style={{ background: color }} />
        <div>
            <div className="sqs-stat-value">{value}</div>
            <div className="sqs-stat-label">{label}</div>
        </div>
    </div>
)

const QualityScoreCard = ({ report, onViewReport }) => {
    if (!report) return null
    const score = report.spraying_efficiency_score || {}
    const coverage = report.coverage || {}
    const color = gradeColor(score)
    return (
        <div className="sqs-card" style={{ borderLeftColor: color }}>
            <ScoreRing score={score.score} max={score.max_score} grade={score.grade} color={color} />

            <div className="sqs-main">
                <div className="sqs-title">
                    Spraying Quality Score
                    <span className="sqs-beta" title="This report is in beta. Results are for guidance and may change as we improve the analysis.">BETA</span>
                </div>
                <div className="sqs-score-line">
                    <span className="sqs-score" style={{ color }}>{fmtValue(score.score, '%')}</span>
                </div>
                <div className="sqs-verdict">{[score.grade && `Grade ${score.grade}`, score.verdict].filter(Boolean).join(' · ') || 'NA'}</div>
            </div>

            <div className="sqs-stats">
                <Stat label="Sprayed" value={fmtPctShort(coverage.sprayed_at_least_once?.pct_of_target)} color={COLORS.coveredOnce} />
                <Stat label="Overlap" value={fmtPctShort(coverage.overlapped_total?.pct_of_target)} color={COLORS.overlap2x} />
                <Stat label="Missed" value={fmtPctShort(coverage.missed?.pct_of_target)} color={COLORS.missed} />
            </div>

            {onViewReport && <button type="button" className="sqs-button" onClick={onViewReport}>
                View report
            </button>}
        </div>
    )
}

export default QualityScoreCard
